import axios from "axios";

export default axios.create({
  baseURL: "https://saverpacific.com/wp-json/api/v2",
  // baseURL: "https://saverpacific.360southclients.com/wp-json/api/v2",
});
